<template>
  <div class="social-status  ">
    <b-modal v-model="showConfirmCancel" type="warn" title="Confirm Cancellation" @ok="clickConfirmCancel" @hide="closeCancel" ok-title="Confirm">
			<p>Please enter a reason for cancelling the social post:</p>
      <b-form-textarea
        :id="`textConfirmCancel-${deliverable.id}`"
        v-model="textConfirmCancel"
        rows="3"
        ref="refTextConfirmCancel"

      ></b-form-textarea>
		</b-modal>
    <b-tooltip v-if="hasTooltip" :target="`social-status-label-${deliverable.id}`" triggers="hover">
      {{deliverable.publish_notes}}
    </b-tooltip>
    <div class="social-status-label" v-bind:style="{background: statusColor}" :id="`social-status-label-${deliverable.id}`" @click="clickStatusLabel">
    	    <div class="status-field exclude-outside-click">
      <multiselect
        ref="customInput"
        :searchable="false"
        v-show="showActionSelect"
        v-model="selectedAction"
        v-click-outside="clickOutside"
        :options="actionOptions"
        @close="showActionSelect=false"
        @input="actionSelected(selectedAction);"
        :show-labels="false"
      >
        <template slot="option" slot-scope="props">
          <div
            :style="{ color: 'var(--wf-secondary)', borderRadius: '5px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }"
          >{{ props.option.name }}</div>
        </template>
      </multiselect>
    </div>
      <span class="status-text">{{ statusText }}</span>
      <span class="unlinked-icon" v-if="deliverable.manually_updated_at">
        <i class="fas fa-unlink clickable" v-if="linkicon" @click="fetchDeliverableDetail"></i>
        <i class="fas fa-unlink" v-else></i>
      </span>

    </div>

  </div>
</template>
<style scoped>

.multiselect {
position: absolute;
margin-top: 30px;
left: 0px;
}

.status-field .multiselect__content-wrapper {
	min-height:40px;
}

</style>
<script>

import { mapState,mapGetters } from "vuex";

export default{
  data() {
    return {
      showActionSelect: false,
      showConfirmCancel: false,
      selectedAction: false,
      textConfirmCancel: "",
    }
  },
  props: ["deliverable", "linkicon", "isList", "namespace", "returnId"],
  computed: {
  	...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  systemSettings (state, getters) {
  	    return getters['systemSettings']
  	  },
  	}),
  	...mapGetters([
  	  "getSystemSetting",
  	  "userAbilities"
  	]),
    publishStatus(){
    	if (this.deliverable.publish_status) {
    	  return JSON.parse(this.deliverable.publish_status);
    	}
    	return null;
    },
    statusColor(){
    	if (this.publishStatus) {
	      return this.publishStatus.color;
	    }
    },
    statusText(){
    	if (this.publishStatus) {
	      return this.publishStatus.name;
	    }
    },
    statusSlug(){
      if (this.publishStatus) {
	      return this.publishStatus.slug;
	    }
    },
    hasTooltip(){
      if(this.deliverable.publish_notes && this.statusSlug == 'cancelled'){
        if(this.deliverable.publish_notes.length){
          return true;
        }
      }
      return false;
    },
    linkLabelIcon(){
      if(this.linkicon){
        return true;
      }
      return false;
    },
    allowedActions(){
      if(this.isList){
        if(this.statusSlug == 'cancelled'){
          return ['undo-cancel-post'];
        } else {
          return ['cancel-post'];
        }
      } else {
        return [
          "cancel-post",
          "undo-cancel-post",
          "approve-publishing",
          "reject-publishing",
          "publish-now",
        ]
      }
    },
    actionOptions(){
      let that = this;
      let options = this.systemSettings?.actions?.filter(function(action){
      if(that.isList){
        if(that.allowedActions.includes(action.slug)){
          return true;
        }
      } else {
      	if (that.deliverable.actions) {
	        if(
	          that.deliverable.actions.includes(action.slug) &&
	          that.allowedActions.includes(action.slug)
	        ){
	          return true;
	        }
	      } else {
	      	if (that.deliverable.publish_status) {
	      		let publishStatus = JSON.parse(that.deliverable.publish_status);
	      		if(publishStatus.slug == 'cancelled'){
		          if(action.slug == 'undo-cancel-post'){
		            return true;
		          }
		          return false;
		        } else {
		        	if(publishStatus.slug == 'ready-for-publishing'){
		        		if(action.slug == 'publish-now'){
		        			if(that.$moment.utc(that.deliverable.publish_date).local().isSame(that.$moment().local())){
		        				return true;
		        			}
		        			if(that.$moment.utc(that.deliverable.publish_date).local().isBefore(that.$moment().local())){
		        				return true;
		        			}
		        		}
		      			if(action.slug == 'reject-publishing'){
		      				return true;
		      			}

		      			if(action.slug == 'publish-now'){
		      				if (that.$moment.utc(that.deliverable.publish_date).local().isBefore(that.$moment())) {
				      				return true;
		      				} else {
			      				if(that.$moment.utc(that.deliverable.publish_date).local().isSame(that.$moment(), 'day')){
			      					if (that.$moment.utc(that.deliverable.publish_date).local().isBefore(that.$moment())) {
				      					return true;
				      				}
			      				}
			      			}
		      			}
		        	} else {
		        		if(publishStatus.slug == "approved") {
			      			if(action.slug == 'approve-publishing'){
			      				if (that.userAbilities.publishSocialMedia) {
				      				if (that.getSystemSetting('social_media___publish_approval_today')) {
					      				if(that.$moment.utc(that.deliverable.publish_date).local().isSame(that.$moment(), 'day') ||
					      					that.$moment.utc(that.deliverable.publish_date).local().isBefore(that.$moment())
					      				 ){
					      					return true;
					      				}
					      			} else {
					      				return true;
					      			}
					      		}
			      			}
			      			if (action.slug == 'publish-now') {

			      				if (that.userAbilities.publishSocialMedia) {
				      				if(that.$moment.utc(that.deliverable.publish_date).local().isSame(that.$moment(), 'day') ||
				      					that.$moment.utc(that.deliverable.publish_date).local().isBefore(that.$moment())
				      				 ){
				      					return true;
				      				}
					      		}
			      			}
			      		}
		      		}
		          if(action.slug == 'cancel-post'){
		            return true;
		          }
		          return false;
		        }
	      	}
	      }
      }
      });
      return options;
    },
    isToday(){
      if(this.$moment.utc(this.deliverable.publish_date).local().isSame(this.$moment(), 'day')){
        return true;
      }
      return false;
    },
  },
  methods: {
    fetchDeliverableDetail(){
      this.$store.dispatch(this.namespace + "getDeliverableDetail", {deliverableId: this.deliverable.id});
    },
    clickStatusLabel(){
      this.showActionSelect = true;
    },
    clickOutside(){
      this.showActionSelect = false;
    },
    actionSelected(action){
    	let that = this;
      this.selectedAction = false;
      this.showActionSelect = false;
      if(action.slug == "cancel-post"){
        this.showConfirmCancel = true;
       	setTimeout(function() {
	       that.$refs.refTextConfirmCancel.focus();
       }, 250);
      } else {
        this.doAction(action);
      }
    },
    clickConfirmCancel(e){
      if(!this.textConfirmCancel.length){
        e.preventDefault();
        document.getElementById("textConfirmCancel-"+this.deliverable.id).focus();
        return;
      }
      this.buttonsDisabled = true;
      let that = this;
      let payload = {
        id: that.deliverable.id,
        value: "cancelled",
        notes: that.textConfirmCancel
      };
      if(!this.isList){
      	payload.return_master = true;
      }

      that.$store.dispatch(that.namespace + "updateDeliverablePublishStatusBySlug", payload
      ).then(function(){
        that.buttonsDisabled = false;
        that.textConfirmCancel = "";
      });
    },
    closeCancel(e){
      if(e.trigger != 'ok'){
        this.textConfirmCancel = "";
      }
    },
    doAction(action){
    	var rid = this.returnId;
    	if (typeof rid == "undefined") {
    		rid = null;
    	}
      this.$store.dispatch(this.namespace + "doAction",{
        deliverable_id: this.deliverable.id,
        return_id: rid,
        action: action.slug,
      }).then(function(response) {
      	  console.log(response);
      });
    },
  },
}
</script>